/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

//
import { sprintf_0xd } from './sprintf-util.js';
import { mj_cloned_object } from './util.js';


export let MetaUtilAutoNumbering = function() {

	function ANCPart( type, value, intern_value ) {
		// 0=text, 1=number, 2=whitespace, 3=token
		this.type = type;

		this.value = value;
		this.intern_value = intern_value;
		this.enabled = false;
		this.options = null;
		if( type===1 ) {
			this.intern_value = parseInt(this.intern_value.toString(),10);
		}
		return this;
	}

	ANCPart.prototype = {
		isNumber: function() {
			return this.type===1;
		},
		isToken: function() {
			return this.type===3;
		},
		isWhitespace: function() {
			return this.type===2;
		},
		getValue: function() {
			return this.value;
		},
		isEnabled: function() {
			return this.enabled;
		},
		getOptions: function( default_options ) {
			return this.options===null ? default_options : this.options;
		},
		setEnabled: function( enable, options ) {
			this.enabled = !!enable;
			this.options = options===null ? null : mj_cloned_object(options);
		},
		guessOptions: function( default_options, cur_media_id, all_media_ids ) {
			var options = mj_cloned_object(this.getOptions(default_options));
			if( this.type===1 ) {
				// numbers
				// guess an offset, based on current value...
				const tmp_part_val_str = this.intern_value.toString();
				//ival = parseInt(tmp_part_val_str,10);
				options.offset = isNaN(this.intern_value) ? 1 : this.intern_value;
				// but decrease offset, when currently selected item is not the first one in the list...
				var i, ml=all_media_ids.length, media_id;
				for( i=0; i<ml; ++i ) {
					media_id = all_media_ids[i];
					if( media_id==cur_media_id ) {
						options.offset -= i;
						break;
					}
				}
				// guess left-padding, based on current values left-padding
				options.lpad = 0;
				if( tmp_part_val_str.charAt(0)=='0' ) options.lpad = tmp_part_val_str.length;
			} else if( this.type==3 ) {
				// token
				// no idea how to guess this
				//options.source_meta_id = 100;
			}
			return options;
		},
		getPartProcessedValue: function( default_options, counter_idx, meta_data ) {
			if( this.enabled ) {
				const options = this.options===null ? default_options : this.options;
				if( this.type===1 ) {
					// numbers
					const r = counter_idx * options.incr + options.offset;
					return options.lpad>1 ? sprintf_0xd(r,options.lpad) : r.toString();
				} else if( this.type===3 ) {
					// token
					// get other value...
					const val_arr = this.options.source_meta_id!==null ? meta_data[this.options.source_meta_id] || [] : [];
					// and just use that value instead of placeholder...
					const tcs = this.options.text_combine_string||',';
					const result_value = val_arr===null ? '' : val_arr.join(tcs);
					if( this.options.whole_empty_when_empty ?? false ) {
						if( result_value==='' ) {
							return null;
						}
					}
					return result_value;
				}
			}
			return this.value;
		},
	};




	var ANCPartList = function( arr_idx ) {
		this.arr_idx = arr_idx;
		this.parts = [];
	};
	ANCPartList.prototype = {
		parsePartListFromValue: function( value, parseOpts, restoreTokensFromPartList ) {
			this.parts = [];

			var reg1, is_numeric_reg, reg3;
			if( parseOpts.negative_numbers ) {
				reg1 = /(-?\d*[.,]\d+|-?\d+|\s+|[{][^\s}]+[}]?|[^\d\s{]+)/g;
				is_numeric_reg = /^(-?\d+)$/;
				reg3 = /^\{(-?\d+)\}$/;
			} else {
				reg1 = /(\d*[.,]\d+|\d+|\s+|[{][^\s}]+[}]?|[^\d\s{]+)/g;
				is_numeric_reg = /^(\d+)$/;
				reg3 = /^\{(\d+)\}$/;
			}

			var tmp_parts = value.match(reg1);
			if( tmp_parts===null ) return;

			//console.log({value,parseOpts,tmp_parts});

			var i, l, v, iv, is_numeric, is_token, is_ws;
			for( i=0, l=tmp_parts.length; i<l; ++i ) {
				v = tmp_parts[i];
				iv = v;
				is_numeric = v.match(is_numeric_reg);
				is_token = v.match(/(^[{][^\s}]+[}]$)/) && v.length>2;
				if( is_token ) {
					var tmp = v.match(reg3);
					if( tmp ) {
						// use numerical type ..
						is_token = false;
						is_numeric = true;
						iv = tmp[1];
					}
					//console.log(v,iv,is_token,is_numeric);
				} else if( !is_numeric ) {
					is_ws = v.match(/(^\s+$)/);
					if( !is_ws && v.length>1 && v[v.length-1]==='-' && i+1<l ) {
						const nextV = tmp_parts[i+1];
						if( nextV.match(is_numeric_reg) && nextV.length>0 && nextV[0]!=='-' ) {
							const charBeforeMinus = v[v.length-2];
							const charsTerminatingWordBeforeMinus = '()[]|,.;:/\\?!+*^°=#"\'§$%&<>_-';
							if( charsTerminatingWordBeforeMinus.indexOf(charBeforeMinus)!==-1 ) {
								// move trailing "minus sign" to beginning of next numeric part ..
								tmp_parts[i+1] = '-' + tmp_parts[i+1];
								v = v.substr(0,v.length-1);
								iv = v;
							}
						}
					}
				} else if( is_numeric && v.length>1 && v[0]==='-' && this.parts.length>1 ) {
					const prevPart = this.parts[this.parts.length-1];
					if( prevPart.isNumber() ) {
						// insert the minus sign as a new text part, ...
						this.parts.push( new ANCPart( 0, '-', '-' ) );
						// ... and interpret _this_ part as a _positive_ number instead
						v = v.substr(1);
						iv = v;
					}
				}
				const newPart = new ANCPart( is_numeric ? 1 : ( is_token ? 3 : (is_ws?2:0) ), v, iv );

				if( is_token ) {
					if( restoreTokensFromPartList.hasOwnProperty(v) ) {
						newPart.setEnabled( true, Object.assign( {}, restoreTokensFromPartList[v] || {} ) );
						// console.log({v,iv,newPartOptions:newPart.options});
					}
				}
				this.parts.push(newPart);
			}
		},
		getParts: function() {
			return this.parts;
		},
		getValue: function() {
			var i, l, r=[];
			for( i=0, l=this.parts.length; i<l; ++i ) {
				r.push( this.parts[i].getValue() );
			}
			return r.join('');
		},
		getPartListProcessedValue: function( default_options, counter_idx, meta_data ) {
			var i, l, r=[];
			for( i=0, l=this.parts.length; i<l; ++i ) {
				const partProcessedValue = this.parts[i].getPartProcessedValue(default_options,counter_idx,meta_data);
				if( partProcessedValue===null ) {
					// force this whole value to become empty value
					return '';
				}
				r.push( partProcessedValue );
			}
			return r.join('');
		},
	};




	var AutoNumberingCounter = function( meta_id ) {
		this.part_lists = [];
		this.meta_id = meta_id;
		this.value = '';
		this.default_options = {
			offset: 1,
			incr: 1,
			lpad: 0,
			source_meta_id: 101,
			text_combine_string: ', ',
			whole_empty_when_empty: false,
		};
	};
	AutoNumberingCounter.prototype = {
		setDefaultOption: function( name, value ) {
			var opts = {};
			opts[name] = value;
			this.setOptions(opts);
		},
		setDefaultOptions: function( options ) {
			// for numbers
			if( options.hasOwnProperty('offset') ) this.default_options.offset = options.offset;
			if( options.hasOwnProperty('incr') ) this.default_options.incr = options.incr;
			if( options.hasOwnProperty('lpad') ) this.default_options.lpad = options.lpad;
			// for tokens
			if( options.hasOwnProperty('source_meta_id') ) this.default_options.source_meta_id = options.source_meta_id;
			if( options.hasOwnProperty('text_combine_string') ) this.default_options.text_combine_string = options.text_combine_string;
			if( options.hasOwnProperty('whole_empty_when_empty') ) this.default_options.whole_empty_when_empty = options.whole_empty_when_empty;
		},

		parseFromValue: function( val_arr, parseOpts, restoreParts ) {
			parseOpts = parseOpts || { negative_numbers: true };

			// const restoreFromPartLists = restoreParts ? this.part_lists : [];
			const restoreTokensFromPartList = {};
			if( restoreParts ) {
				var i, l, j, n;
				for( i=0, l=this.part_lists.length; i<l; ++i ) {
					const parts = this.part_lists[i].getParts();
					for( j=0, n=parts.length; j<n; ++j ) {
						const part = parts[j];
						if( part.isToken() && part.isEnabled() ) {
							// token
							const key = part.getValue();
							restoreTokensFromPartList[key] = part.getOptions();
						}
					}
				}
				// console.log({restoreTokensFromPartList});
			}

			this.part_lists = [];
			for( var arr_idx=0, val_arr_len=val_arr.length; arr_idx<val_arr_len; ++arr_idx ) {
				const pl = new ANCPartList(arr_idx);
				pl.parsePartListFromValue(val_arr[arr_idx],parseOpts,restoreTokensFromPartList);
				this.part_lists.push(pl);
			}
		},
		getPartLists: function() {
			return this.part_lists;
		},
		getPartListAt: function( pl_idx ) {
			if( pl_idx>=0 && pl_idx<this.part_lists.length ) return this.part_lists[pl_idx];
			return null;
		},
		getPartAt: function( pl_idx, p_idx ) {
			if( pl_idx>=0 && pl_idx<this.part_lists.length ) {
				const parts = this.part_lists[pl_idx].getParts();
				if( p_idx>=0 && p_idx<parts.length ) return parts[p_idx];
			}
			return null;
		},

		enablePart: function( pl_idx, p_idx, enable, part_options ) {
			const tmp_part = this.getPartAt(pl_idx,p_idx);
			if( tmp_part===null ) return null;
			tmp_part.setEnabled(enable,part_options);
		},

		isPartEnabled: function( pl_idx, p_idx ) {
			const tmp_part = this.getPartAt(pl_idx,p_idx);
			if( tmp_part===null ) return null;
			return tmp_part.isEnabled();
		},

		getOptionsForPart: function( tmp_part, guess_defaults, cur_media_id, all_media_ids ) {
			if( tmp_part.isEnabled() ) {
				return tmp_part.getOptions(this.default_options);
			} else if( guess_defaults ) {
				return tmp_part.guessOptions(this.default_options,cur_media_id,all_media_ids);
			}
			return null;
		},

		getFirstPartIndices: function() {
			var i,l, j,n;
			for( i=0, l=this.part_lists.length; i<l; ++i ) {
				const parts = this.part_lists[i].getParts();
				for( j=0, n=parts.length; j<n; ++j ) {
					const part = parts[j];
					if( part.type==1 ) {
						return [i,j];
					}
				}
			}
			return null;
		},

		getValue: function() {
			var i, l, r=[];
			for( i=0, l=this.part_lists.length; i<l; ++i ) {
				r.push( this.part_lists[i].getValue() );
			}
			return r;
		},
		getProcessedValue: function( counter_idx, meta_data ) {
			var i, l, r=[];
			for( i=0, l=this.part_lists.length; i<l; ++i ) {
				const partListProcessedValue = this.part_lists[i].getPartListProcessedValue(this.default_options,counter_idx,meta_data);
				r.push( partListProcessedValue );
			}
			return r;
		},
	};


	return {
		createCounter: function( meta_id ) {
			return new AutoNumberingCounter(meta_id);
		},

	};

}(); // namespace XXXUtilAutoNumbering
